import type { PDFDocumentLoadingTask } from 'pdfjs-dist';
import type { ChannelFileContentSource } from '../../lib/api';

export type PdfLoadingTask = PDFDocumentLoadingTask;

export async function createPdfLoadingTask(
  source: ChannelFileContentSource,
): Promise<PdfLoadingTask> {
  const [pdfjs, workerModule] = await Promise.all([
    import('pdfjs-dist'),
    import('pdfjs-dist/build/pdf.worker.min.mjs?url'),
  ]);
  pdfjs.GlobalWorkerOptions.workerSrc = workerModule.default;
  return pdfjs.getDocument({
    url: source.url,
    httpHeaders: source.httpHeaders,
    withCredentials: true,
    // PDF.js only keeps network reads demand-driven when streaming and
    // automatic range prefetching are disabled together.
    disableStream: true,
    disableAutoFetch: true,
    rangeChunkSize: 64 * 1024,
    maxImageSize: 16_777_216,
    canvasMaxAreaInBytes: 64 * 1024 * 1024,
    enableXfa: false,
  });
}

export function isInvalidPdfError(error: unknown): boolean {
  return error instanceof Error && error.name === 'InvalidPDFException';
}

export function isCancelledPdfRender(error: unknown): boolean {
  return error instanceof Error && error.name === 'RenderingCancelledException';
}
